import { SUPPORT_EMAIL, SUPPORT_EMAIL_2, SUPPORT_WHATSAPP_DISPLAY } from './contact';

export const INVOICE_ISSUER_STORAGE_KEY = 'nmhelper_invoice_issuer_cache';
export const PRICE_PER_CLASS_YEAR = 50;

const ISSUER_FIELDS = [
  'issuerName',
  'issuerEmail',
  'issuerEmail2',
  'issuerPhone',
  'issuerAddress',
  'upiId',
  'bankDetails',
  'pricePerClassYear',
  'lineItemDescription',
  'paymentTerms',
  'footerNote',
];

export function getDefaultInvoiceIssuer() {
  return {
    issuerName: 'Nishal K',
    issuerEmail: SUPPORT_EMAIL,
    issuerEmail2: SUPPORT_EMAIL_2,
    issuerPhone: SUPPORT_WHATSAPP_DISPLAY,
    issuerAddress: '',
    upiId: '',
    bankDetails: '',
    pricePerClassYear: PRICE_PER_CLASS_YEAR,
    lineItemDescription: 'NMhelper annual subscription (NM present management)',
    paymentTerms: 'Pay within 7 days via UPI',
    footerNote: 'This invoice is issued without GST registration.',
  };
}

export function normalizeInvoiceIssuer(data) {
  const defaults = getDefaultInvoiceIssuer();
  const src = data && typeof data === 'object' ? data : {};
  const rate = parseFloat(src.pricePerClassYear);
  return {
    issuerName: String(src.issuerName ?? defaults.issuerName).trim(),
    issuerEmail: String(src.issuerEmail ?? defaults.issuerEmail).trim(),
    issuerEmail2: String(src.issuerEmail2 ?? defaults.issuerEmail2).trim(),
    issuerPhone: String(src.issuerPhone ?? defaults.issuerPhone).trim(),
    issuerAddress: String(src.issuerAddress ?? defaults.issuerAddress).trim(),
    upiId: String(src.upiId ?? defaults.upiId).trim(),
    bankDetails: String(src.bankDetails ?? defaults.bankDetails).trim(),
    pricePerClassYear: Number.isFinite(rate) && rate > 0 ? rate : defaults.pricePerClassYear,
    lineItemDescription: String(src.lineItemDescription ?? defaults.lineItemDescription).trim(),
    paymentTerms: String(src.paymentTerms ?? defaults.paymentTerms).trim(),
    footerNote: String(src.footerNote ?? defaults.footerNote).trim(),
  };
}

export function mergeInvoiceIssuer(partial) {
  return normalizeInvoiceIssuer({
    ...getDefaultInvoiceIssuer(),
    ...readCachedInvoiceIssuer(),
    ...(partial && typeof partial === 'object' ? partial : {}),
  });
}

export function readCachedInvoiceIssuer() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem(INVOICE_ISSUER_STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function writeCachedInvoiceIssuer(issuer) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(INVOICE_ISSUER_STORAGE_KEY, JSON.stringify(normalizeInvoiceIssuer(issuer)));
  } catch {
    /* ignore */
  }
}

export function clearCachedInvoiceIssuer() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(INVOICE_ISSUER_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function pickIssuerPayload(issuer) {
  const normalized = normalizeInvoiceIssuer(issuer);
  return ISSUER_FIELDS.reduce((acc, key) => {
    acc[key] = normalized[key];
    return acc;
  }, {});
}
